import { render, staticRenderFns } from "./GuildsSection.vue?vue&type=template&id=6c587741&"
import script from "./GuildsSection.vue?vue&type=script&lang=js&"
export * from "./GuildsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports